export default __webpack_public_path__ + "static/opportunity-milestone-281767ab09af75da8477b2fe5fe9152a.mp4";